export default "__VITE_ASSET__DNNiEtYn__"